import { Info } from "lucide-react";
import { FadeUp, PageHero } from "../components/Reveal";
import { IMG } from "../lib/content";

const UK = [
  { name: "Recorded Delivery", detail: "Royal Mail Signed For — suitable for lower-cost items", price: "£3.75", note: "per order" },
  { name: "Special Delivery", detail: "Royal Mail Special Delivery with insurance, guaranteed delivery within two days", price: "£7.50", note: "insured up to £750" },
  { name: "Special Delivery — Higher Value", detail: "Royal Mail Special Delivery with insurance, guaranteed delivery within two days", price: "£12.15", note: "insured up to £2,500" },
];

const INTL = [
  { name: "Europe & Worldwide", detail: "Standard Post — insurance provided where possible", price: "£12.50", note: "per order" },
  { name: "North America", detail: "Tracked and insured — tracking and insurance included", price: "£22.00", note: "per order" },
];

export default function Shipping() {
  const Card = ({ s }) => (
    <div className="border border-white/5 hover:border-gold/40 transition-colors duration-500 bg-ink-2/40 p-7" data-testid={`shipping-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
      <p className="font-mono text-2xl text-gold mb-2">{s.price}</p>
      <h3 className="font-serif text-xl text-ivory font-light">{s.name}</h3>
      <p className="text-stone-mist text-sm font-light mt-2">{s.detail}</p>
      <p className="text-[11px] uppercase tracking-[0.2em] text-stone-mist mt-4">{s.note}</p>
    </div>
  );

  return (
    <main data-testid="shipping-page">
      <PageHero
        eyebrow="Delivery & Shipping"
        title="How your jewellery reaches you"
        sub="Clear delivery options for the UK, Europe, worldwide and North America."
        image={IMG.peelDusk}
      />
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        <FadeUp>
          <h2 className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-medium">UK Delivery</h2>
        </FadeUp>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {UK.map((s, i) => (
            <FadeUp key={s.name} delay={i * 0.07}><Card s={s} /></FadeUp>
          ))}
        </div>
        <FadeUp>
          <h2 className="text-xs uppercase tracking-[0.25em] text-gold mb-6 font-medium">International Delivery</h2>
        </FadeUp>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-14">
          {INTL.map((s, i) => (
            <FadeUp key={s.name} delay={i * 0.07}><Card s={s} /></FadeUp>
          ))}
        </div>
        <FadeUp>
          <div className="border border-gold/30 bg-gold/5 p-8" data-testid="shipping-notice">
            <div className="flex items-center gap-3 mb-4">
              <Info className="w-5 h-5 text-gold" />
              <h2 className="font-serif text-xl text-ivory font-light">Important shipping information</h2>
            </div>
            <ul className="space-y-2.5 text-stone-mist text-sm font-light">
              <li>· Larger or more expensive items may require separate delivery arrangements.</li>
              <li>· A delivery supplement may apply to larger or higher-value items.</li>
              <li>· Please mention any special shipping instructions when placing your order.</li>
              <li>· Celtic Gold is based on the Isle of Man — weather conditions may occasionally affect postal services.</li>
            </ul>
          </div>
        </FadeUp>
      </section>
    </main>
  );
}
